"use strict";
import "lodash";
import { svc_fetchAll, svc_fetchOne, svc_addOne, svc_editOne, svc_deleteOne, svc_search } from "@/services";
import { svc_getTerminals } from "@/services/staff";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";
import { convertISODateTimeToString } from "@/utils/convertTime";
import config from "@/../config/config.json";

const endpointBasePrefix = "menu-status";

const Model = {
    namespace: "m_MenuStatus",
    state: {
        statuses: {},
        itemCodes: []
    },
    reducers: {
        handleFetchAll(state, { payload: { statuses } }) {
            return { ...state, statuses };
        },
        handleFetchItemCodes(state, { payload: { itemCodes } }) {
            return { ...state, itemCodes };
        },
    },
    effects: {
        *fetchAll({ payload }, { call, put }) {
            let statuses = yield call(svc_search, endpointBasePrefix, payload);
            if (statuses === "") {
                statuses = { status: "OK", result: [], count: 0 };
            }
            if (!showServerResponse(statuses, true)) return;

            _.forEach(statuses.result, function (row) {
                row.key = row.id;
				row = convertISODateTimeToString(row, ["expire_at"], config.dateTimeFormat);
            });

            yield put({
                type: "handleFetchAll",
                payload: { statuses },
            });

            return statuses;
        },
        *addOne({ payload }, { call, put }) {
            payload = _.omit(payload, ["id", "key"]);
            const response = yield call(svc_addOne, endpointBasePrefix, payload);
            showServerResponse(response);
            return response;
        },
        *editOne({ payload }, { call, put }) {
            if (payload && payload.id) {
                const response = yield call(svc_editOne, endpointBasePrefix, payload, "id");
                showServerResponse(response);
                return response;
            }
        },
        *deleteOne({ payload }, { call, put }) {
            if (payload && payload.id) {
                payload = _.omit(payload, ["key"]);
                const response = yield call(svc_deleteOne, endpointBasePrefix, payload, "id");
                showServerResponse(response);
                return response;
            }
        },
        *fetchItemCodes({ payload }, { call, put }) {
            if (!payload || !payload.item_code) return
            
            let itemCodes = yield call(svc_search, `${endpointBasePrefix}/code-search`, payload);
            _.forEach(itemCodes.result, function (row) {
				row.key = row.code;
			});
			
			return itemCodes.result;
        },
    },
    subscriptions: {},
};

export default Model;
